// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2LVJp","button":"styles_button__ICG4k","link":"styles_link__lJsTy"};